import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);
  const [msg, setMsg] = useState('signing you in…');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    // Clean the URL fragment
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
    }
    (async () => {
      try {
        await exchangeSession(sessionId);
        navigate('/deals', { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || 'sign in failed';
        setMsg(detail);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-lilac-100 via-white to-mint-100 p-6">
      <div className="text-center max-w-md">
        <Logo size="lg" />
        <p className="mt-4 text-sm text-slate-600">{msg}</p>
        <button onClick={() => navigate('/login')} className="mt-6 text-xs text-mint-700 hover:text-mint-800 underline">back to sign in</button>
      </div>
    </div>
  );
};

export default AuthCallback;
